module.exports = __webpack_public_path__ + "img/mail.4b512176.svg";